import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { treatmentAfterExpirationConfig } from './TreatmentAfterExpiration.name';

/** 満了後の扱いのENUM */
enum TreatmentAfterExpiration {
  /** 再リース */
  reLease = '1',
  /** 返却 */
  giveBack = '2',
  /** 購入 */
  purchase = '3',
  /** 廃棄 */
  discard = '4',
}

const treatmentAfterExpirationMap = new Map([
  ['1', TreatmentAfterExpiration.reLease],
  ['2', TreatmentAfterExpiration.giveBack],
  ['3', TreatmentAfterExpiration.purchase],
  ['4', TreatmentAfterExpiration.discard],
]);

const rawValueToTreatmentAfterExpiration = rawValueToEnumWithDefault(
  treatmentAfterExpirationMap,
  TreatmentAfterExpiration.giveBack,
);

const rawValueToOrEmptyTreatmentAfterExpiration = rawValueToEnumWithDefault(treatmentAfterExpirationMap, '');

const treatmentAfterExpirationToDisplay = enumToNameWithDefault(
  TreatmentAfterExpiration,
  treatmentAfterExpirationConfig,
);

export {
  TreatmentAfterExpiration,
  rawValueToOrEmptyTreatmentAfterExpiration,
  rawValueToTreatmentAfterExpiration,
  treatmentAfterExpirationToDisplay,
};
